import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PanelInfo from '../../../labels/PanelInfo';
import Menu from './Families';
import Error from '../../../dialogs/Error';

import { bindActionCreators } from 'redux';
import * as actionsprocess from '../../../../actions/api.manage.process.actions';
import * as home from '../../../../actions/process.home.actions';

class Index extends React.Component {
    state = {};

    constructor(props) {
        super(props);
        const {
            manage_process,
            manage_process_is_loading,
            manage_process_has_error,
            family,
        } = props;
        if (
            !family ||
            !manage_process ||
            !manage_process.families ||
            manage_process_is_loading ||
            manage_process_has_error.hasErrored
        ) {
            props.loadManageProcesses();
        }
    }

    UNSAFE_componentWillMount() {
        this.props.setSearch(true);
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    render() {
        const { code, family, form, info, windows_search, manage_process } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        }
        console.log("manage_process", manage_process);
        return (
            <div className={'flex_full_row bg_ice_blue'}>
                <div
                    className={
                        'flex_40 shadow_right_on_tablet bg_ice_blue ' +
                        (code === 2 ? 'hide' : '')
                    }
                >
                    <Menu windows_search={windows_search} code={1} active={family} />
                </div>
                {code === 1 && <PanelInfo id={'manage_aux_message'} />}
                {code === 2 && (
                    <div
                        className={
                            'flex_60 padding_top_12 shadow_right_on_tablet bg_cloudy_blue_30 '
                        }
                    >
                        <Menu
                            windows_search={windows_search}
                            code={2}
                            family={family}
                            form={form}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsprocess, home), dispatch);
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        session: state.session,
        manage_process: state.manage_process,
        manage_process_is_loading: state.manage_process_is_loading,
        manage_process_has_error: state.manage_process_has_error,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Index.js